import { RichTextV1Schema, RichTextGenerationV1Schema } from './version1';
import { createVersionedSchema } from '@mutiny-pkg/versioned-schema/src/index';

export { RichTextV1Schema, RichTextGenerationV1Schema } from './version1';

export const RichTextSchema = createVersionedSchema().defineVersion(RichTextV1Schema);
export const RichTextGenerationSchema = createVersionedSchema().defineVersion(RichTextGenerationV1Schema);

export * from './RichInput.types';
export * from './streaming';
